import { useError } from "../../context/useErrorContext"
import { GetRequest, PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { EPlanCouponDiscountType } from "../../Enum/EPlanCouponDiscountType"
import { EPlanCouponApprovalStatus } from "../../Enum/EPlanCouponApprovalStatus"
import { useTranslation } from "react-i18next"

export interface ResellerCoupon {
  id: number
  code: string
  discountType: EPlanCouponDiscountType
  discountValue: number
  approvalStatus: EPlanCouponApprovalStatus
  isActive: boolean
  rejectionReason: string | null
  createdAt: string
}

export interface RequestResellerCouponRequest {
  code: string
  discountType: EPlanCouponDiscountType
  discountValue: number
}

export const useResellerCoupons = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetResellerCoupons = async (onSuccess: (coupons: ResellerCoupon[]) => void) => {
    try {
      const response = await GetRequest<ResellerCoupon[]>(API_ROUTES.RESELLER.COUPONS, ERequestType.Reseller)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  const handleRequestResellerCoupon = async (request: RequestResellerCouponRequest, onSuccess: () => void) => {
    try {
      const response = await PostRequest(API_ROUTES.RESELLER.COUPONS, request, ERequestType.Reseller)

      if (!response.success) {
        throw new Error(response.message)
      }

      onSuccess()
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleGetResellerCoupons, handleRequestResellerCoupon }
}
